import React from 'react'

const HeaderPadrao = ({ 
  title = 'Relatório', 
  empresa = '', 
  dateLabel = '',
  navbarInfo = {}
}) => {
  const branchCode = navbarInfo?.empresa || empresa || '—'
  const branchAcronym = navbarInfo?.sigla || '—'
  const employeeName = navbarInfo?.nome || ''

  return (
    <div className="report-header" style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '12px 16px', borderBottom: '2px solid #4a5568',
      background: '#111827', color: '#ffffff'
    }}>
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            background: '#f59e0b', color: '#111827', borderRadius: 4, padding: '4px 8px',
            fontWeight: 700, fontSize: 12
          }}>{branchCode}</span>
          <span style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            background: '#ef4444', color: '#ffffff', borderRadius: 4, padding: '4px 8px',
            fontWeight: 600, fontSize: 12
          }}>{branchAcronym}</span>
        </div>
      </div>
      <div style={{ flex: 1, textAlign: 'center' }}>
        <h2 style={{ margin: 0, fontSize: '16px', color: '#ffffff' }}>{title}</h2>
      </div>
      <div style={{ flex: 1, textAlign: 'right' }}>
        <div style={{ fontSize: 12, opacity: 0.9 }}>{employeeName}</div>
        <p style={{ margin: 0, fontSize: '12px' }}>{dateLabel}</p>
      </div>
    </div>
  )
}

export default HeaderPadrao